import Vue from 'vue'
import router from '@router'
import store from '@store'
import App from './App'
import Plugins from './plugins'
import * as Sentry from '@sentry/vue'
import { Replay } from '@sentry/browser'
import {
  HttpClient as HttpClientIntegration
} from '@sentry/integrations'
import { BrowserTracing } from '@sentry/tracing'
import release from '../release'
import './helpers/colors'
import './helpers/changeUser'

/* istanbul ignore if */
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN_KEY,
    release: 'clube-admin-front@' + release,
    integrations: [
      new BrowserTracing(),
      new HttpClientIntegration({
        failedRequestTargets: [
          process.env.API,
          process.env.GRAPHQL
        ]
      }),
      new Replay({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    debug: true,
    logErrors: true,
    sendDefaultPii: true,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'Failed to fetch',
      'Non-Error promise rejection captured',
      'Navigation cancelled from',
      'Navigation aborted from',
      'Avoided redundant navigation to current location',
      'Blocked a frame with origin',
      /Loading chunk [\d]+ failed/,
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage',
      'Script error.',
      '_avast_submit_'
    ],
    denyUrls: [
      // Google Adsense
      /pagead\/js/i,
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
    ],
    tracesSampleRate: 1.0
  })
  Sentry.configureScope(function (scope) {
    scope.setLevel('error')
  })
}

if (process.env.USE_MOCKS) {
  const mocks = require('./mocks/server')
  mocks.makeServer()
}

Vue.config.productionTip = false

if (window.Cypress) {
  // Add `store` to the window object only when testing with Cypress
  window.__store__ = store
}

Vue.use(Plugins)

global.process = {
  ...process,
  env: {
    ...process.env
  }
}

const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App />'
})

export default vue



// WEBPACK FOOTER //
// ./src/index.js